/**
 * @generated SignedSource<<8449ea8b49630294e8528cea84470223>>
 * @relayHash 185a3811d54fa4dbaa3c798a6842379e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 185a3811d54fa4dbaa3c798a6842379e

import { ConcreteRequest } from 'relay-runtime';
export type NumberOfEmployeesRange = "C_00001_00010" | "C_00011_00050" | "C_00051_00100" | "C_00101_00250" | "C_00251_00500" | "C_00501_01000" | "C_01001_05000" | "C_05001_10000" | "C_10001_MAX" | "%future added value";
export type UpdateUserProfileInput = {
  avatarImage?: UploadedImageInput | null;
  avatarImageId?: string | null;
  bio?: string | null;
  clientOnboardingGoals?: CreateUserClientOnboardingGoalsInput | null;
  externalLinks?: ReadonlyArray<ExternalLinkInput> | null;
  firstName?: string | null;
  generalInquiryCtaIsVisible?: boolean | null;
  hiringAsIndividual?: boolean | null;
  independentPortfolioTemplateThemeId?: string | null;
  introductionVideo?: UpdateUserProfileIntroductionVideoInput | null;
  lastName?: string | null;
  locationGooglePlaceId?: string | null;
  minimumHourlyRate?: number | null;
  organization?: OrganizationInput | null;
  professionalTitle?: string | null;
  roles?: ReadonlyArray<RoleInput> | null;
  title?: string | null;
};
export type UploadedImageInput = {
  animated: boolean;
  checksum?: string | null;
  height: number;
  originalFormat: string;
  resourceType?: string | null;
  sizeBytes: number;
  uid: string;
  width: number;
};
export type CreateUserClientOnboardingGoalsInput = {
  estimatedBudget?: string | null;
  idealStartDate?: string | null;
  interestedInMatchmaking?: boolean | null;
  phoneNumber?: string | null;
  projectDuration?: string | null;
  rolesLookingToHire?: ReadonlyArray<string> | null;
  selectedGoals: ReadonlyArray<string>;
};
export type ExternalLinkInput = {
  label?: string | null;
  url: any;
};
export type UpdateUserProfileIntroductionVideoInput = {
  displayLabel?: string | null;
  isEnabled?: boolean | null;
  video?: UploadedVideoInputV2 | null;
};
export type UploadedVideoInputV2 = {
  audioCodecName?: string | null;
  checksum?: string | null;
  duration: number;
  height: number;
  originalFormat: string;
  sizeBytes: number;
  uid: string;
  videoCodecName?: string | null;
  width: number;
};
export type OrganizationInput = {
  associate?: AssociateOrganizationInput | null;
  create?: CreateOrganizationInput | null;
  update?: UpdateOrganizationInput | null;
};
export type AssociateOrganizationInput = {
  id: string;
};
export type CreateOrganizationInput = {
  description?: string | null;
  locationGooglePlaceId?: string | null;
  logoImage?: UploadedImageInput | null;
  logoImageUid?: string | null;
  name: string;
  numberOfContractorsWorkingWith?: NumberOfContractorsWorkingWithRangeInput | null;
  url: any;
};
export type NumberOfContractorsWorkingWithRangeInput = {
  max: number;
  min: number;
};
export type UpdateOrganizationInput = {
  description?: string | null;
  externalLinks?: ReadonlyArray<ExternalLinkInput> | null;
  founderNames?: ReadonlyArray<string> | null;
  id: string;
  industryCategoryIds?: ReadonlyArray<string> | null;
  location?: string | null;
  locationGooglePlaceId?: string | null;
  logoImage?: UploadedImageInput | null;
  logoImageUid?: string | null;
  name?: string | null;
  numberOfContractorsWorkingWith?: NumberOfContractorsWorkingWithRangeInput | null;
  numberOfEmployees?: NumberOfEmployeesRange | null;
  url?: any | null;
  yearFounded?: number | null;
};
export type RoleInput = {
  name: string;
};
export type LinksUpdateExternalLinksMutation$variables = {
  input: UpdateUserProfileInput;
};
export type LinksUpdateExternalLinksMutation$data = {
  readonly updateUserProfile: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly userAccount: {
      readonly profile: {
        readonly externalLinks: {
          readonly count: number;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly label: string | null;
              readonly url: string;
            };
          }>;
        };
      };
    } | null;
  };
};
export type LinksUpdateExternalLinksMutation = {
  response: LinksUpdateExternalLinksMutation$data;
  variables: LinksUpdateExternalLinksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfileExternalLinkConnection",
  "kind": "LinkedField",
  "name": "externalLinks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileExternalLinkEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileExternalLink",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinksUpdateExternalLinksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinksUpdateExternalLinksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "185a3811d54fa4dbaa3c798a6842379e",
    "metadata": {},
    "name": "LinksUpdateExternalLinksMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ccb9aa9104b5b3ec0278a6d4f1bbe3f4";

export default node;
